import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { GradientStats, SectionIntro } from '#src/app/pages/about/impact/shared/components';

const STATS = [
	{
		figure: translationKey('corgi.impact_page.behind_every_petition.stats.notified.figure'),
		label: translationKey('corgi.impact_page.behind_every_petition.stats.notified.label'),
	},
	{
		figure: translationKey('corgi.impact_page.behind_every_petition.stats.relationships.figure'),
		label: translationKey('corgi.impact_page.behind_every_petition.stats.relationships.label'),
	},
] as const;

export const BehindEveryPetition: React.FC<EmptyProps> = () => {
	return (
		<section className="container flex flex-col gap-10 pb-16 md:gap-14 md:pb-32">
			<SectionIntro
				eyebrow={translationKey('corgi.impact_page.behind_every_petition.eyebrow')}
				heading={translationKey('corgi.impact_page.behind_every_petition.heading')}
				body={translationKey('corgi.impact_page.behind_every_petition.body')}
				align="center"
			/>
			<GradientStats stats={STATS} align="center" />
		</section>
	);
};
